import { Button } from '../ui/button';
import { X } from 'lucide-react';

const PRESETS = [
  { id: 'none', label: 'None', filters: { brightness: 0, contrast: 0, saturation: 0, blur: 0, warmth: 0 } },
  { id: 'cinematic', label: 'Cinematic', filters: { brightness: -5, contrast: 20, saturation: -10, blur: 0, warmth: 15 } },
  { id: 'moody', label: 'Moody', filters: { brightness: -15, contrast: 25, saturation: -20, blur: 0, warmth: 0 } },
  { id: 'vibrant', label: 'Vibrant', filters: { brightness: 10, contrast: 15, saturation: 40, blur: 0, warmth: 5 } },
  { id: 'warm', label: 'Warm', filters: { brightness: 5, contrast: 5, saturation: 10, blur: 0, warmth: 30 } },
  { id: 'cool', label: 'Cool', filters: { brightness: 0, contrast: 10, saturation: -10, blur: 0, warmth: -20 } },
  { id: 'noir', label: 'Noir', filters: { brightness: -10, contrast: 30, saturation: -80, blur: 0, warmth: 0 } },
  { id: 'bright', label: 'Bright', filters: { brightness: 25, contrast: 5, saturation: 15, blur: 0, warmth: 0 } },
  { id: 'dreamy', label: 'Dreamy', filters: { brightness: 10, contrast: -10, saturation: 20, blur: 1, warmth: 10 } },
];

const SLIDERS = [
  { key: 'brightness', label: 'Brightness', min: -50, max: 50 },
  { key: 'contrast', label: 'Contrast', min: -50, max: 50 },
  { key: 'saturation', label: 'Saturation', min: -100, max: 100 },
  { key: 'warmth', label: 'Warmth', min: -50, max: 50 },
  { key: 'blur', label: 'Blur', min: 0, max: 10 },
];

export default function FilterPanel({ filters, setFilters, preset, setPreset, onClose }) {
  const applyPreset = (p) => {
    setPreset(p.id);
    setFilters({ ...filters, ...p.filters });
  };

  return (
    <div className="bg-card border-t border-border p-3 max-h-72 overflow-y-auto" data-testid="filter-panel">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium">Filters & Effects</span>
        <Button variant="ghost" size="icon" onClick={onClose}><X className="w-4 h-4" /></Button>
      </div>

      {/* Presets */}
      <div className="flex gap-2 overflow-x-auto pb-3 mb-3">
        {PRESETS.map(p => (
          <button key={p.id} onClick={() => applyPreset(p)}
            className={`px-4 py-2 rounded-lg text-xs font-medium whitespace-nowrap border transition-all ${
              preset === p.id ? 'border-violet-500 bg-violet-500/10 text-violet-300' : 'border-border text-muted-foreground/80'
            }`}
            data-testid={`filter-${p.id}`}>
            {p.label}
          </button>
        ))}
      </div>

      {/* Manual sliders */}
      <div className="space-y-2.5">
        {SLIDERS.map(s => (
          <div key={s.key} className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground w-20">{s.label}</span>
            <input type="range" min={s.min} max={s.max} value={filters[s.key]}
              onChange={e => { setFilters({ ...filters, [s.key]: parseInt(e.target.value) }); setPreset('custom'); }}
              className="flex-1 accent-violet-500" data-testid={`slider-${s.key}`} />
            <span className="text-xs text-muted-foreground w-8 text-right">{filters[s.key]}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
